<div piTesting="sellerToolsPeekPanelBase">
    <mat-divider class="peek-divider"></mat-divider>
    <mat-tab-group
        disableRipple="true"
        [attr.mat-align-tabs]="'center'"
        [dynamicHeight]="false"
        (selectedTabChange)="handleTabChange($event)"
        [selectedIndex]="sellerToolsTabs.indexOf(activeTab)"
    >
        <mat-tab>
            <ng-template mat-tab-label piTesting="openInvitationTab">{{
                'seller-tools-panel.invitation-links.tab-title' | translate
            }}</ng-template>
            <platform-open-invitation
                class="seller-tools-tab-container"
                (closePeek)="closePeek()"
            ></platform-open-invitation>
        </mat-tab>
        @if (enableDemoAndWorkshopTabs) {
            <mat-tab>
                <ng-template mat-tab-label piTesting="prospectDemosTab">{{
                    'seller-tools-panel.prospect-demos.tab-title' | translate
                }}</ng-template>
                <prospect-demos
                    class="seller-tools-tab-container"
                    [selectedDemoUserData]="sellerToolPeekData.prospectData"
                    [openCreateDemo]="
                        sellerToolPeekData.sellerToolType ===
                        SellerToolType.ProspectDemos
                    "
                ></prospect-demos>
            </mat-tab>
        }
        @if (enableDemoAndWorkshopTabs) {
            <mat-tab>
                <ng-template mat-tab-label piTesting="workshopAccountsTab">{{
                    'seller-tools-panel.workshop-accounts.tab-title' | translate
                }}</ng-template>
                <workshop-accounts
                    class="seller-tools-tab-container"
                ></workshop-accounts>
            </mat-tab>
        }
    </mat-tab-group>
    @if (activeTab !== sellerToolsTabs[0]) {
        <div class="seller-tools-peek--footer-container">
            <mat-divider></mat-divider>
            @if (showDeleteFeature) {
                <div class="button-section">
                    <tapestry-button
                        [text]="'text.common-terms.cancel' | translate"
                        [color]="'secondary'"
                        (buttonClicked)="closePeek()"
                    ></tapestry-button>
                    <tapestry-button
                        [text]="primaryFooterKey"
                    ></tapestry-button>
                </div>
            }
        </div>
    }
</div>
